<template>
  <div>
    <div class="css-grid battery-order-view__row battery-order-view__row--form">
      <div class="css-grid battery-order-view__order">
        <div class="battery-order-view__cell">
          <StoreConnectedSelect placeholder="Battery Line *" :store="store" name="batteryLine" :options="batteryLines" options-label="battery_line" options-value="battery_line" :disabled="batteryLines.length === 0"></StoreConnectedSelect>
        </div>
      </div>

      <div class="css-grid battery-order-view__order">
        <div class="battery-order-view__cell">
          <StoreConnectedSelect placeholder="Battery Size *" :store="store" name="batterySize" :options="batterySizes" :disabled="!batteryLine"></StoreConnectedSelect>
        </div>
      </div>

      <div class="css-grid battery-order-view__order">
        <div class="battery-order-view__cell">
          <StoreConnectedSelect placeholder="Pack Size *" :store="store" name="packSize" :options="packSizes" :disabled="!batterySize"></StoreConnectedSelect>
        </div>
      </div>


      <div class="css-grid battery-order-view__order">
        <div class="battery-order-view__cell h-helper-text" v-if="product">{{ product.description }}</div>
        <div class="battery-order-view__cell battery-order-view__cell--placeholder" v-else>Product Description</div>
      </div>

      <div class="css-grid battery-order-view__order">
        <div class="battery-order-view__cell">
          <StoreConnectedSelect placeholder="Imprint *" :store="store" name="imprint" :options="imprintOptions" :disabled="!batterySize"></StoreConnectedSelect>
        </div>
      </div>

      <div class="css-grid battery-order-view__order">
        <div class="battery-order-view__cell">
          <StoreConnectedInput placeholder="Quantity *" :store="store" name="quantity" class="h-center-align" :debounce="false" :disabled="!packSize"></StoreConnectedInput>
        </div>
      </div>

      <div class="css-grid battery-order-view__order h-center-align">
        <div class="battery-order-view__cell" v-if="product && imprint && quantity">
          <div v-if="itemPrice">{{ itemPrice }} <span v-if="pricePerCell">({{ pricePerCell }}/cell)</span></div>
          <div class="h-center-align" v-else>
            <PulseLoader></PulseLoader>
          </div>
        </div>
        <div class="battery-order-view__cell battery-order-view__cell--placeholder" v-else>Price</div>
      </div>

      <div class="css-grid battery-order-view__order h-center-align">
        <div class="battery-order-view__cell" v-if="product && quantity">
          <div v-if="totalBatteries">{{ totalBatteries }} batteries</div>
          <div class="h-center-align" v-else>
            <PulseLoader></PulseLoader>
          </div>
        </div>
        <div class="battery-order-view__cell battery-order-view__cell--placeholder" v-else>Batteries</div>
      </div>

      <div class="css-grid battery-order-view__order h-center-align">
        <div class="battery-order-view__cell">
          <button class="btn btn-primary" :disabled="!itemValid" @click.prevent="addToOrder">Add to Order</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
  import DataMethods from '../../utils/DataMethods.js';
  import StoreConnectedSelect from '../../form-items/StoreConnectedSelect.vue';
  import StoreConnectedInput from '../../form-items/StoreConnectedInput.vue';

  export default {
    name: 'ProductForm',
    mixins: [DataMethods],
    components: {
      PulseLoader,
      StoreConnectedInput,
      StoreConnectedSelect,
    },
    data() {
      return {
        store: 'batteryStore',
      };
    },
    computed: {
      ...mapGetters('batteryStore', [
        'loaders',
        'product',
        'batteryLines',
        'batterySizes',
        'packSizes',
        'batteryLine',
        'batterySize',
        'packSize',
        'quantity',
        'imprint',
      ]),
      imprintOptions() {
        return [
          {
            label: 'No Imprint',
            value: 'No Imprint',
          },
          {
            label: 'New Imprint',
            value: 'New Imprint',
          },
          {
            label: 'Current Imprint',
            value: 'Current Imprint',
          },
        ];
      },
      itemPrice () {
        if (this.product && parseInt(this.quantity) > 0 && this.imprint) {
          if (this.imprint === 'No Imprint') {
            return this.currency(this.quantity * this.product.base_price / 100, '$', 2);
          } else {
            return this.currency(this.quantity * this.product.price_imprint / 100, '$', 2);
          }
        }
        return '';
      },
      pricePerCell() {
        if (this.product && parseInt(this.quantity) > 0 && this.imprint) {
          if (this.imprint === 'No Imprint') {
            return this.currency((this.product.base_price / this.product.total_batteries) / 100, '$', 2);
          } else {
            return this.currency((this.product.price_imprint / this.product.total_batteries) / 100, '$', 2);
          }
        }
        return '';
      },
      totalBatteries() {
        return  (this.product && parseInt(this.quantity) > 0) ? parseInt(this.quantity) * this.product.total_batteries : '';
      },
      itemValid() {
        return this.product && this.imprint && this.quantity;
      },
    },
    methods: {
      addToOrder() {
        this.$store.dispatch('batteryStore/addToOrder');
      },
    },
  };
</script>

<style>
  .battery-order-view__cell .checkbox label {
    padding-left: 0;
  }
</style>
